const appointment = {
  secondaryTickets: {
    label: "Ticket secondaire",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    }
  },
  refereeClient: {
    label: "Référent client"
  },
  cause: {
    label: "Constat"
  },
  result: {
    label: "Résultat"
  },
  file: {
    label: "Fichier"
  },
  fileSigned: {
    label: "Fichier signé"
  },
  appointmentType: {
    label: "Type d'intervention"
  },
  yousignOperatorMode: {
    label: "Transmission code Yousign",
    options: {
      mail: "Mail",
      sms: "SMS"
    }
  },
  yousignResult: {
    label: "Résultat Yousign",
    options: {
      procedureOngoing: "En cours",
      procedureFinished: "Terminé",
      procedureRefused: "Refusé",
      procedureExpired: "Expiré",
      procedureDeleted: "Supprimé",
    }
  },
  yousignStatus: {
    label: "Status",
    options: {
      ongoing: "En cours",
      done: "Terminé",
      declined: "Refusé",
      expired: "Expiré",
      deleted: "Supprimé",
    }
  },
  yousignLink: {
    label: "Signer"
  },
  appointmentProducts: {
    label: "Fourniture",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    }
  },
  usedAppointmentActions: {
    label: "Actions",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    }
  },
  timeSlot: {
    label: "Durée",
    invalid: {
      assertEmpty: "La durée ne peut pas être vide."
    }
  },
  dateStart: {
    label: "Date de début",
    invalid: {
      assertEmpty: "La date ne peut pas être vide."
    }
  },
  dateEnd: {
    label: "Date de fin",
    invalid: {
      assertEmpty: "La date ne peut pas être vide."
    }
  }
};

export default appointment;
